import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import moment from 'moment';
import { DeliveryDate } from '@aid/product-contract/types/classes';

@Component({
  selector: 'aid-product-contract-delivery-date-form',
  template: `
    <form [formGroup]="form" class="aid-layout-column aid-layout-gap-32">
      <div class="aid-layout-column aid-layout-gap-16">
        <aid-date-picker
          [label]="'date'"
          [control]="date"
          [minDate]="currentDate"
        >
        </aid-date-picker>

        <aid-input [label]="'customer-number'" [control]="customerNumber">
        </aid-input>
      </div>

      <aid-form-actions
        [buttonLeft]="'cancel'"
        [buttonRight]="'submit'"
        [form]="form"
        [disable]="form.invalid"
        (clickRight)="onSubmit()"
        (clickLeft)="cancel.emit()"
      ></aid-form-actions>
    </form>
  `,
  styleUrls: ['./product-contract-delivery-date-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProductContractDeliveryDateFormComponent implements OnInit {
  form: UntypedFormGroup = this.formBuilder.group({
    date: [null, Validators.required],
    customerNumber: [null, Validators.required]
  });
  currentDate = new Date();

  @Output() cancel = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {}

  get date() {
    return this.form.get('date') as UntypedFormControl;
  }

  get customerNumber() {
    return this.form.get('customerNumber') as UntypedFormControl;
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.form.pending) {
      return;
    }
    const deliveryDate = new DeliveryDate();
    deliveryDate.date = moment(this.date.value).format('YYYY-MM-DD');
    deliveryDate.customer = this.customerNumber.value;

    this.submit.emit(deliveryDate);
  }
}
